export default __webpack_public_path__ + "static/media/lendnest3.2c89c041.jpg";